import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IService } from "../servicesModal";

export const getAllServices = createAsyncThunk(
  "Service/FindAllService",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/FindAllService`,
        {
          ServicesTitle: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createServices = createAsyncThunk(
  "Service/InsertService",
  async (ServicesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/InsertService`,
        ServicesData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateServices = createAsyncThunk(
  "Service/UpdateService",
  async (ServicesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/UpdateService`,
        ServicesData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteServices = createAsyncThunk(
  "Service/DeleteService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/DeleteService`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getServicesByID = createAsyncThunk(
  "Service/FindByIDService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/FindByIDService`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        CoreServiceID: result.CoreServiceID,
        Title: result.Title,
        SubTitle: result.SubTitle,
        PageDetails: result.PageDetails,
        CtaTemplate: result.CtaTemplate,
        CtaImage: result.CtaImage,
        BreakDown: result.BreakDown,
        BreakDownImage: result.BreakDownImage,
        URL: result.URL,
        MetaTitle: result.MetaTitle,
        MetaKeywords: result.MetaKeywords,
        MetaDescription: result.MetaDescription,
        IsActive: result.IsActive ? 1 : 2,
      } as IService;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveServices = createAsyncThunk(
  "Service/FindAllActiveService",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Service/FindAllActiveService`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveServices = createAsyncThunk(
  "Service/ActiveInActiveService",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/ActiveInActiveService`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const ServicesDetailsImageUpload = createAsyncThunk(
  "Service/ServiceImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/ServiceImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Service Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
